export const VIP_PLATFORM = `vip_szty`;
export const STORE_ID = 'e59ee920-87b2-11ef-af2a-1fe0774f5d12';
